import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useInterval } from 'usehooks-ts';
import Colors from '../../utils/color';

export const ASSIST_COUNTDOWN_TICK_MS = 250;
/** At or under this many seconds the countdown turns red. */
export const ASSIST_URGENT_S = 5;

/**
 * Whole seconds to `deadlineAt`, a LOCAL epoch (receipt + `remaining_ms` minus
 * the network margin). Never a server time: agent PC clocks drift by minutes.
 */
export const remainingSeconds = (deadlineAt: number, now: number) =>
  Math.max(0, Math.ceil((deadlineAt - now) / 1000));

const AssistCountdown = ({ deadlineAt }: { deadlineAt: number }) => {
  const [now, setNow] = useState(() => Date.now());
  useInterval(() => setNow(Date.now()), ASSIST_COUNTDOWN_TICK_MS);
  const seconds = remainingSeconds(deadlineAt, now);
  const urgent = seconds <= ASSIST_URGENT_S;
  return (
    <Box
      component="span"
      role="timer"
      data-testid="assist-countdown"
      sx={{
        fontFamily: 'monospace',
        fontSize: 15,
        fontVariantNumeric: 'tabular-nums',
        color: urgent ? Colors.amaranth : 'inherit',
        fontWeight: urgent ? 700 : 400,
      }}
    >
      {seconds}s
    </Box>
  );
};

export default AssistCountdown;
